import { render, staticRenderFns } from "./Markenverwaltung.vue?vue&type=template&id=1ac57f24&scoped=true&"
import script from "./Markenverwaltung.vue?vue&type=script&lang=js&"
export * from "./Markenverwaltung.vue?vue&type=script&lang=js&"
import style0 from "./Markenverwaltung.vue?vue&type=style&index=0&id=1ac57f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac57f24",
  null
  
)

export default component.exports